import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Box, Button, Grid, ListItemText, Typography } from '@mui/material';
import {
  classes,
  StyledMenu,
  ListItemsHeader,
  CancelButton,
  SelectedFilterTypo,
  ListElement,
  FilterBox,
} from './utils';
import './AgGrid.css';
import { lightPalette } from '../../../../theme';
// import { ReactComponent as ResetFilter } from '../../../../assets/common-assets/resetFilter.svg';
import CustomFilter from './CustomFIlter';
import Toast from '../../utils/Toast';

const CustomFilterModel = (props) => {
  const {
    open,
    anchorEl,
    handleClose,
    columnDefs,
    gridKey,
    columnApi,
    gridSettingData,
    handleCustomFilter,
    handleResetFilter,
  } = props;
  const [currentTab, setCurrentTab] = useState('1');
  const [columnData, setColumnData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState();
  const [filterDropDownList, setFilterDropdownList] = useState({});
  const childRef = useRef();
  useEffect(() => {
    if (gridSettingData && gridSettingData?.filter) {
      const filterModelKeys =
        Object.keys(gridSettingData?.filter?.filterModel).length > 0;
      const filterDropdownKeys =
        Object.keys(gridSettingData?.filter?.dropDownFilter).length > 0;
      const data = {};
      if (filterModelKeys) {
        Object.values(gridSettingData?.filter?.filterModel).forEach((value) => {
          if (Object.keys(value).length > 0) {
            Object.assign(data, gridSettingData?.filter?.filterModel);
          }
        });
      }
      if (filterDropdownKeys) {
        Object.values(gridSettingData?.filter?.dropDownFilter).forEach(
          (value) => {
            if (value.length > 0) {
              Object.assign(data, gridSettingData?.filter?.dropDownFilter);
            }
          },
        );
      }
      setFilterDropdownList(data);
    }
  }, [gridSettingData]);
  useEffect(() => {
    if (columnDefs.length) {
      const data = columnDefs
        .filter((elem) => elem.type)
        .map((elem, index) => ({
          label: elem.headerName,
          type: elem.type,
          value: `${index + 1}`,
          field: elem.field,
          headerName: elem.headerName,
        }));
      setColumnData(data);
      setSelectedFilter(data[0]);
    }
  }, [columnDefs]);
  const selectedTabFilter = (element) => {
    setCurrentTab(element.value);
    setSelectedFilter(element);
  };
  const handleCallChild = (item) => {
    if (childRef.current) {
      childRef.current.callChildFunction(item);
    }
  };
  const handleDeleteFilter = (key, index = null) => {
    setFilterDropdownList((prev) => {
      const updatedFilters = { ...prev };
      if (Array.isArray(updatedFilters[key]) && index !== null) {
        updatedFilters[key].splice(index, 1);
        if (updatedFilters[key].length === 0) {
          delete updatedFilters[key];
        }
      } else {
        delete updatedFilters[key];
      }
      handleCallChild(updatedFilters);
      return updatedFilters;
    });
  };

  const clearFilter = async () => {
    if (Object.keys(filterDropDownList).length > 0) {
      await handleResetFilter();
      handleCallChild({});
      setFilterDropdownList({});
      handleClose();
    }
  };
  const handleApplyFilter = async () => {
    if (Object.keys(filterDropDownList).length === 0) {
      Toast({
        message: 'At least one filter must be select!',
        variant: 'warning',
      });
      return;
    }
    const filterModel = {};
    const filterDropdown = {};
    Object.entries(filterDropDownList).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        filterDropdown[key] = value;
      } else if (typeof value === 'object') {
        filterModel[key] = value;
      }
    });
    const colState = columnApi.getColumnState();
    const sortedColumn = colState.find((col) => col.sort !== null);
    await handleCustomFilter(
      gridKey,
      sortedColumn,
      filterModel,
      filterDropdown,
    );
    handleClose();
  };
  const renderTextDateContent = (value) => {
    if (value.filterType === 'date') {
      return (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <SelectedFilterTypo variant="body2">
            {value.dateFrom}
          </SelectedFilterTypo>
          <span>-</span>
          <SelectedFilterTypo variant="body2">
            {value.dateTo}
          </SelectedFilterTypo>
        </Box>
      );
    }
    if (value.filterType === 'text') {
      return (
        <SelectedFilterTypo variant="body2">{value.filter}</SelectedFilterTypo>
      );
    }
  };
  const renderContent = (data) =>
    Object.keys(data).map((key) => {
      const value = data[key];

      if (Array.isArray(value)) {
        return (
          <Box
            key={key}
            sx={{ mb: 2 }}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography variant="body1">
              <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
            </Typography>
            {value.map((item, index) => (
              <Box
                key={`${index + 1}`}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <SelectedFilterTypo variant="body2">
                  {item.label}
                </SelectedFilterTypo>
                <CancelOutlinedIcon
                  sx={{ height: '14px', width: '14px', cursor: 'pointer' }}
                  onClick={() => handleDeleteFilter(key, index)}
                />
              </Box>
            ))}
          </Box>
        );
      }

      if (value.filterType === 'text' || value.filterType === 'date') {
        return (
          <Box
            key={key}
            sx={{ mb: 2 }}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography variant="body1">
              <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
            </Typography>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              {renderTextDateContent(value)}
              <CancelOutlinedIcon
                sx={{ height: '14px', width: '14px', cursor: 'pointer' }}
                onClick={() => handleDeleteFilter(key)}
              />
            </Box>
          </Box>
        );
      }

      return null;
    });

  return (
    <div>
      <StyledMenu
        id="demo-customized-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        {...props}
      >
        <Grid container style={{ width: '530px', minHeight: '300px' }}>
          <Grid item xs={3} style={{ background: 'rgba(43, 30, 89, 0.05)' }}>
            <Box
              style={{
                padding: '10px',
              }}
            >
              <Typography
                variant="h5"
                component="div"
                className={classes.ExternalHeaderTitle}
              >
                Filter
              </Typography>
              <Box style={{ marginTop: '12px' }}>
                <ListElement
                  sx={{
                    '&::-webkit-scrollbar': {
                      width: '0.4em',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#888', // Scrollbar thumb color
                      borderRadius: '5px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555', // Thumb hover color
                      borderRadius: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: 'transparent', // Track color
                      borderRadius: '5px',
                    },
                    scrollbarWidth: 'thin', // For Firefox
                    scrollbarColor: '#888 transparent', // For Firefox
                  }}
                >
                  {columnData.map((element, index) => (
                    <ListItemsHeader
                      key={`${index + 1}`}
                      sx={{
                        background:
                          currentTab === element.value &&
                          lightPalette.primary.lighter,
                        '&:hover': {
                          backgroundColor: lightPalette.primary.lighter,
                        },
                      }}
                      onClick={() => {
                        selectedTabFilter(element);
                      }}
                    >
                      <ListItemText
                        primary={`${element.label}`}
                        sx={{
                          color:
                            currentTab === element.value
                              ? lightPalette.primary.main
                              : lightPalette.lightGrey.main,
                        }}
                      />
                    </ListItemsHeader>
                  ))}
                </ListElement>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={9}
            style={{
              boxShadow:
                '-4px 0px 1px -2px rgba(0, 0, 0, 0.1), -1px 0px 3px rgba(0, 0, 0, 0.05)',
            }}
          >
            <Box
              style={{
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <Grid container style={{ height: '100%' }}>
                <Grid item xs={7}>
                  <CustomFilter
                    ref={childRef}
                    FilterType={selectedFilter}
                    gridKey={gridKey}
                    setFilterDropdownList={setFilterDropdownList}
                    filterDropDownList={filterDropDownList}
                  />
                </Grid>
                <Grid item xs={5}>
                  <SelectedFilterTypo variant="body2">
                    {`${Object.keys(filterDropDownList).length} Selected filter `}
                  </SelectedFilterTypo>
                  <FilterBox sx={{ mt: 2 }}>
                    {renderContent(filterDropDownList)}
                  </FilterBox>
                </Grid>
              </Grid>

              {/* Add margin or spacing between content */}
              <Box sx={{ flexGrow: 1 }} />

              {/* Button Grid always at the bottom */}
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Button onClick={clearFilter} variant="text" color="primary">
                    Clear all
                  </Button>
                </Grid>
                <Grid item>
                  <CancelButton sx={{ mr: 1 }} onClick={handleClose}>
                    Cancel
                  </CancelButton>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleApplyFilter}
                  >
                    Apply
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </StyledMenu>
    </div>
  );
};
CustomFilterModel.defaultProps = {
  columnApi: null,
  gridSettingData: null,
};
CustomFilterModel.propTypes = {
  anchorEl: PropTypes.shape({}).isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  columnDefs: PropTypes.arrayOf.isRequired,
  gridKey: PropTypes.string.isRequired,
  columnApi: PropTypes.shape({
    getColumnState: PropTypes.func.isRequired,
  }),
  handleCustomFilter: PropTypes.func.isRequired,
  handleResetFilter: PropTypes.func.isRequired,
  gridSettingData: PropTypes.shape({
    id: PropTypes.string,
    user_id: PropTypes.string,
    grid_key: PropTypes.string,
    sort: PropTypes.shape({
      column: PropTypes.string,
      sort: PropTypes.string,
    }),
    filter: PropTypes.shape({
      dropDownFilter: PropTypes.shape({}).isRequired,
      filterModel: PropTypes.shape({}).isRequired,
    }),
  }),
};
export default CustomFilterModel;
